import { useQuery } from '@tanstack/react-query';
import { PASSPORT_DETAILS_KEY } from '../../utils/constants/queryKeys';
import { getPassportDetails } from '../services/fn-api/Passports';

export const useGetPassportDetails = (beneId: number | undefined, dependentId: number | undefined) => {
  return useQuery({
    queryKey: [PASSPORT_DETAILS_KEY, beneId, dependentId],
    queryFn: () => getPassportDetails(beneId, dependentId),
    enabled: !!beneId || !!dependentId,
  });
};
